module.exports = __webpack_public_path__ + "static/media/Data_insight_en_3-1.1b171a41.svg";